<!--
  ~ Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-dialog [header]="translationSchema.task.list.deleteMessage | translate"
          [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true">
  <div class="flex flex-column">
    <div class="flex flex-column mb-3">
      <span>{{ translationSchema.task.list.deleteQuestionTask | translate }}</span>
      <div class="mt-1">
        <button pButton
                [label]="translationSchema.task.list.deleteTaskOnly | translate"
                (click)="deleteTaskOnly()"></button>
      </div>
    </div>

    <div class="flex flex-column mb-3">
      <span>{{ translationSchema.task.list.deleteQuestionSegment | translate }}</span>
      <div class="mt-1">
        <button pButton
                [label]="translationSchema.task.list.deleteSegment | translate"
                [disabled]="!segmentsDeletable()"
                (click)="deleteSegment()"></button>
      </div>
    </div>

    <div class="flex flex-column">
      <span>{{ translationSchema.task.list.deleteQuestionSolution | translate }}</span>
      <div class="mt-1">
        <span [pTooltip]="!solutionsDeletable() ? (translationSchema.task.list.solutionNotDeletable | translate) : (translationSchema.task.list.solutionDeletableWarning | translate)">
          <button pButton
                  [label]="translationSchema.task.list.deleteEntireSolution | translate"
                  [disabled]="!solutionsDeletable()"
                  (click)="deleteTaskAndSolution()"></button>
        </span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-text"
            [label]="translationSchema.utils.close | translate"
            (click)="visible.set(false)"></button>
  </ng-template>
</p-dialog>
